import * as React from "react";
import { LiveScoreboard, LiveTableHeader, LiveTableBody } from "../../components";
export class DefaultLiveScoreboardMobile extends React.PureComponent {
    render() {
        const { header, title, liveGameState, team1Name, team2Name, team1Scores, team2Scores } = this.props;
        return (React.createElement(LiveScoreboard, null,
            React.createElement(LiveTableHeader, Object.assign({}, { header, title, liveGameState })),
            React.createElement(LiveTableBody, Object.assign({}, { team1Name, team2Name, team1Scores, team2Scores }))));
    }
}
//# sourceMappingURL=DefaultLiveScoreboardMobile.js.map